module.exports = __webpack_public_path__ + "media/images/fischer_banner/banner__sponsor__sidebar-11a07184bb2caed94b7418fff45140c5.png";